// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import formValidation from './form-validation';
import isAmountOfUseModalOpen from './amount-of-use-modal-visibility';
import previousDeliveryDate from './registration-previous-delivery-date';
import product from './product-details';
import registration from './registration';
import registrationDomainValues from './registration-domain-values';
import registrationModals from './registration-modals';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    formValidation,
    isAmountOfUseModalOpen,
    previousDeliveryDate,
    product,
    registration,
    registrationDomainValues,
    registrationModals
});



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/index.js